import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["date", "dateLabel", "dateHelper", "title", "titleHelper", "notes", "status"]
  static values = { copies: Object, localDate: String }

  connect() {
    this.sync()
  }

  sync() {
    const copy = this.copiesValue[this.statusTarget.value]

    if (this.hasDateTarget) {
      if (this.statusTarget.value === "cooked" && this.hasLocalDateValue) {
        this.dateTarget.max = this.localDateValue
      } else {
        this.dateTarget.removeAttribute("max")
      }
    }

    this.element.dispatchEvent(new CustomEvent("meal-log-state-copy:updated", { bubbles: true }))

    if (!copy) return

    if (this.hasDateLabelTarget) this.dateLabelTarget.textContent = copy.date_label
    if (this.hasDateHelperTarget) this.dateHelperTarget.textContent = copy.date_helper
    if (this.hasTitleTarget) this.titleTarget.placeholder = copy.title_placeholder
    if (this.hasTitleHelperTarget) this.titleHelperTarget.textContent = copy.title_helper
    if (this.hasNotesTarget) this.notesTarget.placeholder = copy.notes_placeholder
  }
}
